import BaseProduct from './BaseProduct';
import { ProductId } from '../types';
import store, { getLayerOpacity } from '../state';
import ManifestTimelineHelper from '../services/ManifestTimelineHelper';

export class PrecipLayer extends BaseProduct {
  public readonly id: ProductId = 'precip';
  private unsubscribe: (() => void) | null = null;

  protected onActivate(): void {
    if (!this.unsubscribe) {
      let lastModelsStr = JSON.stringify(store.getState().selectedModels);
      let lastMode = store.getState().precipViewMode;
      this.unsubscribe = store.subscribe((state) => {
        const nextModelsStr = JSON.stringify(state.selectedModels);
        const nextMode = state.precipViewMode;
        if (nextModelsStr !== lastModelsStr || nextMode !== lastMode) {
          lastModelsStr = nextModelsStr;
          lastMode = nextMode;
          this.refresh();
        }
      });
    }
    this.refresh();
  }

  protected onDeactivate(): void {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
    }
    this.layerManager.removeBufferedRasterLayer(this.id);
  }

  protected onTimeUpdate(_date: string, _hour: string): void {
    this.refresh();
  }

  public refresh(targetTimeMs?: number) {
    if (!this.active) return;
    const state = store.getState();
    const manifest = state.manifest;
    if (!manifest) return;

    const opacity = getLayerOpacity(this.id, 1.0);
    const current = targetTimeMs !== undefined ? targetTimeMs : state.currentTimeStep;
    if (!current) return;

    const mode = state.precipViewMode || 'hourly';
    let targetProduct: ProductId = 'precip';
    let activeModel = state.selectedModels['precip'] || 'ecmwf';

    if (mode === '24h_snow') {
      targetProduct = 'snow_24h';
      activeModel = state.selectedModels['snow_24h'] || 'nbm';
    } else if (mode === '24h' || mode === '24h_rain') {
      targetProduct = 'precip_24h';
      activeModel = state.selectedModels['precip_24h'] || 'nbm';
    } else if (mode === 'prob') {
      targetProduct = 'precip_prob';
      activeModel = state.selectedModels['precip_prob'] || state.selectedModels['precip'] || 'nbm';
    }

    let resolvedProduct: ProductId = targetProduct;
    let resolvedModel = activeModel;
    if (ManifestTimelineHelper.getProductFrames(manifest, resolvedProduct, resolvedModel).length === 0) {
      if (ManifestTimelineHelper.getProductFrames(manifest, resolvedProduct, 'nbm').length > 0) {
        resolvedModel = 'nbm';
      } else if (ManifestTimelineHelper.getProductFrames(manifest, 'precip', activeModel).length > 0) {
        resolvedProduct = 'precip';
      }
    }

    const maxZoom = resolvedProduct === 'precip_prob' ? 4 : 5;
    this.updateStandardInterpolatedRaster({
      layerId: this.id,
      product: resolvedProduct,
      model: resolvedModel,
      targetTime: current,
      opacity,
      minzoom: 0,
      maxzoom: maxZoom
    });
  }
}
export default PrecipLayer;
